// import classToggle from '../helpers/class-toggle';
import { Splide } from '@splidejs/splide';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import toggle from '../helpers/class-toggle';
import scrollTop from '../components/scroll-top';
import idx from '../helpers/idx';

export default () => {
	document.body.classList.remove('is-breadcrumbs-open');

	const section = document.querySelector('.product');
	const slides = document.querySelectorAll('.product__gallery-slide:not(.product__gallery-slide--hide-desktop)');
	// const container = document.querySelector('.product__container');

	const fixedEls = document.querySelectorAll('.product__indicators');
	if (!section) { return };

	if (section && fixedEls.length) {
		ScrollTrigger.create({
			trigger: section,
			start: "bottom bottom",
			end: "+=100%",
			// markers: {startColor: "green", endColor: "red", fontSize: "12px"},
			scrub: true,
			onUpdate: (self) => {
				const progressPx = self.progress * (self.end - self.start)
				// console.log(self.progress * (self.end - self.start));
				// console.log(self);
				// console.log(self.scroll());

				gsap.set(fixedEls, {
					bottom: progressPx
				})
			}
		});

		// Read more
		const readMore = document.querySelector('[data-read-more]');
		if (readMore) {
			readMore.addEventListener('click', () => {
				const previewDesc = document.querySelector('[data-desc-preview]');
				const fullDesc = document.querySelector('[data-desc-full]');

				previewDesc.setAttribute('aria-expanded', 'false');
				fullDesc.setAttribute('aria-expanded', 'true');

				previewDesc.classList.remove('is-expanded');
				fullDesc.classList.add('is-expanded');
			});
		}

		const readLess = document.querySelector('[data-read-less]');
		if (readLess) {
			readLess.addEventListener('click', () => {
				const previewDesc = document.querySelector('[data-desc-preview]');
				const fullDesc = document.querySelector('[data-desc-full]');

				previewDesc.setAttribute('aria-expanded', 'true');
				fullDesc.setAttribute('aria-expanded', 'false');

				previewDesc.classList.add('is-expanded');
				fullDesc.classList.remove('is-expanded');
			});
		}

		let currentSlide;
		let indicators = document.querySelectorAll('.product__indicator');
		// console.log(indicators);
		// console.log(slides);

		if (indicators.length && slides.length) {
			let st = ScrollTrigger.create({
				trigger: section,
				start: "top 1%",
				end: "bottom bottom",
				//markers: {startColor: "green", endColor: "red", fontSize: "12px"},
				scrub: true,
				onUpdate: (self) => {
					let val = Math.round(self.progress * (slides.length - 1));
					// console.log({val});

					if (val !== currentSlide) {
						currentSlide = val;
						toggle(indicators, indicators[val], 'product__indicator--active');
					}
				}
			});
		}
	}

	// popup tabs
	const popupButtons = document.querySelectorAll('.tabs__switch');
	const tabs = document.querySelectorAll('.tabs__slide');
	const ACTIVE_BTN = 'tabs__switch--active';
	const ACTIVE_TAB = 'tabs__slide--active';

	if (popupButtons.length && tabs.length) {
		popupButtons.forEach(function (btn, index) {
			btn.addEventListener('click', (e) => {
				let isChanged = toggle(popupButtons, btn, ACTIVE_BTN);

				if (isChanged) {
					const activeTab = document.querySelector('.tabs__slide--active');
					const oldIndex = idx(activeTab)
					// console.log({oldIndex});

					gsap.set(tabs[index], {
						opacity: 0
					})

					let tl = gsap.timeline();
					tl.to(tabs[oldIndex], {
						opacity: 0,
						duration: 0.3,
						onComplete: () => {
							toggle(tabs, tabs[index], ACTIVE_TAB);
						}
					});

					tl.to(tabs[index], {
						opacity: 1,
						duration: 0.3,
						onComplete: () => {
							gsap.set(tabs[oldIndex], {
								opacity: 1
							})
						}
					})
				}
			});
		});
	}

	// main tabs
	const buttonsWrapper = document.querySelector('.product__buttons');
	const btnClose = document.querySelector('.js-close-tabs');
	const body = document.body;

	if (buttonsWrapper) {
		const buttons = buttonsWrapper.querySelectorAll('.product__button');

		buttons.forEach(function (button, index) {
			button.addEventListener('mouseenter', (e) => {
				buttonsWrapper.classList.add('product__buttons--hover');
			});
			button.addEventListener('mouseleave', (e) => {
				buttonsWrapper.classList.remove('product__buttons--hover');
			});

			button.addEventListener('click', (e) => {
				// section.classList.add('is-tabs-opened');
				if (window.innerWidth >= 1024) {
					scrollTop();
				}

				body.classList.add('is-tabs-opened');
				toggle(popupButtons, popupButtons[index], ACTIVE_BTN);
				toggle(tabs, tabs[index], ACTIVE_TAB);
			});
		});

		if (btnClose) {
			btnClose.addEventListener('click', (e) => {
				// section.classList.remove('is-tabs-opened');
				body.classList.remove('is-tabs-opened');
			});
		}
	}

	const sliderEl = document.querySelector('.product__gallery');
	const splide = new Splide(sliderEl, {
		type: "fade",
		rewind: true,
		perPage: 1,
		speed: 700,
		arrows: false,
		pagination: false,
		drag: true,
		keyboard: true,
		breakpoints: {
			1023: {
				//type: 'slide',
				rewind: false,
				focus: 0,
				pagination: true,
				arrows: false,
				perPage: 1,
				perMove: 1,
				speed: 700,
			}
		}
	}).mount();

	var thumbnails = document.querySelectorAll('.gallery__thumb');

	function updateActiveThumb(index) {
		thumbnails.forEach((thumb, i) => {
			if (i === index) {
				thumb.classList.add('gallery__thumb--active');
			} else {
				thumb.classList.remove('gallery__thumb--active');
			}
		});
	}

	thumbnails.forEach((thumbnail, index) => {
		thumbnail.addEventListener('click', function () {
			splide.go(index);
			updateActiveThumb(index);
		});
	});

	splide.on('moved', function (newIndex) {
		updateActiveThumb(newIndex);
	});

	updateActiveThumb(0);

	// ZOOM FUNCTIONALITY
	function initZoom() {
		const zoomBtns = document.querySelectorAll('.product__zoom');
		const gallerySlides = document.querySelectorAll('.product__gallery-slide');

		if (zoomBtns.length == 0 || !gallerySlides.length) return;

		// Create zoom modal
		const zoomModal = createZoomModal();
		document.body.appendChild(zoomModal);

		// Create zoom slider
		const zoomSlider = createZoomSlider(zoomModal);

		// Zoom button click handler
		zoomBtns.forEach((zoomBtn) => {
			zoomBtn.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();
			openZoomModal(zoomModal, zoomSlider);
			});
		});
  

		// Close modal handlers
		const closeBtn = zoomModal.querySelector('.zoom-modal__close');
		const overlay = zoomModal.querySelector('.zoom-modal__overlay');

		closeBtn.addEventListener('click', () => closeZoomModal(zoomModal));
		overlay.addEventListener('click', () => closeZoomModal(zoomModal));

		// ESC key handler
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && zoomModal.classList.contains('is-open')) {
				closeZoomModal(zoomModal);
			}
		});
	}

	function createZoomModal() {
		const modal = document.createElement('div');
		modal.className = 'zoom-modal';
		modal.innerHTML = `
			<div class="zoom-modal__overlay"></div>
			<div class="zoom-modal__content">
				<button class="zoom-modal__close" aria-label="Close zoom">
					<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M13 1L1 13" stroke="black"/>
						<path d="M0.999999 1L13 13" stroke="black"/>
					</svg>
				</button>
				<div class="zoom-modal__slider"></div>
			</div>
		`;
		return modal;
	}

	function createZoomSlider(modal) {
		const sliderContainer = modal.querySelector('.zoom-modal__slider');
		const gallerySlides = document.querySelectorAll('.product__gallery-slide');

		// Create slider HTML with thumbnails
		sliderContainer.innerHTML = `
			<div class="zoom-slider splide">
				<div class="splide__track">
					<div class="splide__list">
						${Array.from(gallerySlides).map((slide, index) => {
			const media = slide.querySelector('.product__gallery-media');
			if (media.tagName === 'IMG') {
				return `
									<div class="splide__slide zoom-slide">
										<div class="zoom-slide__container">
											<img 
												src="${media.src}" 
												alt="${media.alt}"
												class="zoom-slide__image"
												loading="lazy"
											>
										</div>
									</div>
								`;
			} else if (media.tagName === 'VIDEO') {
				return `
									<div class="splide__slide zoom-slide">
										<div class="zoom-slide__container">
											<video 
												src="${media.src}" 
												class="zoom-slide__video"
												autoplay 
												loop 
												muted 
												controls
											></video>
										</div>
									</div>
								`;
			}
		}).join('')}
					</div>
				</div>
			</div>
			<div class="zoom-modal__thumbs hover-group">
				${Array.from(gallerySlides).map((slide, index) => {
			const media = slide.querySelector('.product__gallery-media');
			const activeClass = index === 0 ? 'zoom-modal__thumb--active' : '';

			if (media.tagName === 'IMG') {
				return `
							<div class="zoom-modal__thumb ${activeClass} hover-group__item" data-slide="${index}">
								<img 
									src="${media.src}" 
									alt="${media.alt}"
									class="zoom-modal__thumb-img"
									loading="lazy"
								>
							</div>
						`;
			} else if (media.tagName === 'VIDEO') {
				return `
							<div class="zoom-modal__thumb ${activeClass} hover-group__item" data-slide="${index}">
								<video 
									src="${media.src}" 
									class="zoom-modal__thumb-img"
									muted
									loop
									preload="metadata"
								></video>
							</div>
						`;
			}
		}).join('')}
			</div>
		`;

		// Initialize zoom slider
		const zoomSlider = new Splide(sliderContainer.querySelector('.zoom-slider'), {
			type: 'fade',
			rewind: true,
			perPage: 1,
			speed: 500,
			arrows: false,
			pagination: false,
			keyboard: true,
			wheel: false,
			wheelSleep: 300,
			drag: false
		});

		zoomSlider.mount();

		// Add thumbnail click handlers
		const thumbs = sliderContainer.querySelectorAll('.zoom-modal__thumb');
		thumbs.forEach((thumb, index) => {
			thumb.addEventListener('click', () => {
				zoomSlider.go(index);
				updateZoomActiveThumb(thumbs, index);
			});
		});

		// Update thumbnails when slider changes
		zoomSlider.on('moved', (newIndex) => {
			updateZoomActiveThumb(thumbs, newIndex);
		});

		// Add pan and zoom functionality to images
		addPanZoomToImages(sliderContainer);

		return zoomSlider;
	}

	function updateZoomActiveThumb(thumbs, activeIndex) {
		thumbs.forEach((thumb, index) => {
			if (index === activeIndex) {
				thumb.classList.add('zoom-modal__thumb--active');
			} else {
				thumb.classList.remove('zoom-modal__thumb--active');
			}
		});
	}

	function addPanZoomToImages(container) {
		const images = container.querySelectorAll('.zoom-slide__image');

		images.forEach(img => {
			let state = {
				scale: 1,
				panX: 0,
				panY: 0,
				isZoomed: false
			};

			// Clamp panX/panY so image stays within view
			function clampPan(pan, maxPan) {
				return Math.max(-maxPan, Math.min(maxPan, pan));
			}

			function updateTransform() {
				img.style.transform = `scale(${state.scale}) translate(${state.panX}px, ${state.panY}px)`;
			}

let lastMouseX = 0;
let lastMouseY = 0;
let isHoverPanning = false;

img.addEventListener('click', (e) => {
	const rect = img.getBoundingClientRect();

	if (!state.isZoomed) {
		state.scale = 2.25;
		state.isZoomed = true;
		img.style.cursor = 'zoom-out';

		state.panX = 0;
		state.panY = 0;

		isHoverPanning = true;
		lastMouseX = e.clientX;
		lastMouseY = e.clientY;
	} else {
		state.scale = 1;
		state.panX = 0;
		state.panY = 0;
		state.isZoomed = false;
		isHoverPanning = false;
		img.style.cursor = 'zoom-in';
	}

	updateTransform();
});

img.addEventListener('mousemove', (e) => {
	if (!state.isZoomed || !isHoverPanning) return;

	const deltaX = e.clientX - lastMouseX;
	const deltaY = e.clientY - lastMouseY;

	// Update last mouse position
	lastMouseX = e.clientX;
	lastMouseY = e.clientY;

	// Apply inverted movement (like dragging the image)
	state.panX += deltaX * -1;
	state.panY += deltaY * -1;

	// Clamp pan based on zoom scale and image bounds
	const rect = img.getBoundingClientRect();
	const maxPanX = (img.naturalWidth * state.scale - rect.width) / 2;
	const maxPanY = (img.naturalHeight * state.scale - rect.height) / 2;

	state.panX = clampPan(state.panX, maxPanX);
	state.panY = clampPan(state.panY, maxPanY);

	updateTransform();
});

			img.addEventListener('reset-zoom', () => {
				state.scale = 1;
				state.panX = 0;
				state.panY = 0;
				state.isZoomed = false;
				img.style.cursor = 'zoom-in';
				updateTransform();
			});

			img.style.cursor = 'zoom-in';
		});
	}

	function openZoomModal(modal, zoomSlider) {
		const currentIndex = splide.index;

		// Sync zoom slider with main slider
		zoomSlider.go(currentIndex);

		// Show modal
		modal.classList.add('is-open');
		document.body.classList.add('zoom-modal-open');

		// Reset all zoom states
		modal.querySelectorAll('.zoom-slide__image').forEach(img => {
			img.dispatchEvent(new Event('reset-zoom'));
		});
	}

	function closeZoomModal(modal) {
		modal.classList.remove('is-open');
		document.body.classList.remove('zoom-modal-open');
	}

	// Initialize zoom functionality
	initZoom();

	if (window.innerWidth >= 1024) {
		setLayout();
	}
	window.addEventListener('resize', () => {
		if (window.innerWidth >= 1024) {
			setLayout();
		}
	});

	const content = document.querySelector('.product__main');
	const header = document.querySelector('.header');

	function setLayout() {
		const section = document.querySelector('.product');
		if (!section) return;

		const header = document.querySelector('.header');
		const headerHeight = header.offsetHeight;
		const inner = document.querySelector('.product__inner');
		const productMain = document.querySelector('.product__main');
		const ar = +getComputedStyle(section).getPropertyValue('--images-ar') || 1.5408;

		const heightGap = inner.offsetHeight - headerHeight - productMain.offsetHeight;
		const w = heightGap * ar;

		ScrollTrigger.refresh();
		if (window.innerWidth >= 1024) {
			// checkLayout();
		}
	}

	function checkLayout() {
		const grid = document.querySelector('.product__grid');
		const images = document.querySelector('.product__images');
		const main = document.querySelector('.product__main');
		const header = document.querySelector('.header');

		const heightDiff = grid.offsetHeight - images.offsetHeight - main.offsetHeight - header.offsetHeight;

		if (heightDiff < 0) {
			setLayout();
		}
	}

	if (content && section) {
		updateVars();

		window.addEventListener('resize', (e) => {
			setTimeout(function () {
				updateVars();
			}, 30);
		});
	}

	// get variant id from URL and apply as active size
	const url = window.location.href;
	const variantId = url.split('variant=')[1];

	if (variantId) {
		const sizeBtn = document.querySelector(`.sticky-add .select__list-item[data-id="${variantId}"]`);
		if (sizeBtn) {
			// Delay click event until select.js has initialised
			window.setTimeout(function () {
				sizeBtn.click();
			}, 30)
		}
	}

	function updateVars() {
		let contentHeight = content.offsetHeight;
		let contentOffset = content.offsetTop - header.offsetHeight;
		let popupHeight = window.innerHeight - header.offsetHeight - contentHeight;
		setCssVar(section, 'popup-height', `${popupHeight}px`);
		setCssVar(section, 'content-offset', `${contentOffset}px`);
	}

	function setCssVar(element, name, value) {
		element.style.setProperty(`--${name}`, value);
	}

	const lookSection = document.querySelector('.look');
	const gotoLookBtn = document.querySelector('.product__images-btn');

	if (gotoLookBtn) {
		if (!lookSection) {
			gotoLookBtn.remove();
		} else {
			gotoLookBtn.style.visibility = 'visible';
		}
	}

	function setStateClass(el, state) {
		if (!el) return;

		const classes = el.classList;
		for (let i = 0; i < classes.length; i++) {
			if (classes[i].startsWith('is-')) {
				classes.remove(classes[i]);
			}
		}
		classes.add(`is-${state}`);
	}

	document.querySelectorAll('.product__free-returns--btn').forEach(element => {
		element.addEventListener('click', () => {
			const deliveryTab = document.querySelector('.tabs__switch-delivery');
			if (deliveryTab) {
				deliveryTab.click();
			}
		});
	});
}